import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    // crypto side (coin you send)
    currency: "USDC",
    network: "",
    amount: "",
    pin: "",

    // fiat recipient
    recipient: {
        institution: "",
        accountIdentifier: "",
        accountName: "",
        bankName: "",
        memo: "",
        toCurrency: "NGN",
    },
};

const cryptoFiatTransferSlice = createSlice({
    name: "cryptoFiatTransfer",
    initialState,
    reducers: {
        setCryptoFiatAmount: (state, { payload }) => {
            state.amount = payload;
        },
        setCryptoFiatCurrency: (state, { payload }) => {
            state.currency = payload;
        },
        setCryptoFiatNetwork: (state, { payload }) => {
            state.network = payload;
        },
        setCryptoFiatPin: (state, { payload }) => {
            state.pin = payload;
        },

        setCryptoFiatRecipient: (state, { payload }) => {
            const next = { ...(payload || {}) };
            if (next.currency && !next.toCurrency) {
                next.toCurrency = next.currency;
                delete next.currency;
            }
            state.recipient = { ...state.recipient, ...next };
        },

        setCryptoFiatRecipientToCurrency: (state, { payload }) => {
            state.recipient.toCurrency = payload;
        },

        setCryptoFiatInstitution: (state, { payload }) => {
            state.recipient.institution = payload;
        },
        setCryptoFiatBankName: (state, { payload }) => {
            state.recipient.bankName = payload;
        },
        setCryptoFiatAccountIdentifier: (state, { payload }) => {
            state.recipient.accountIdentifier = payload;
        },
        setCryptoFiatAccountName: (state, { payload }) => {
            state.recipient.accountName = payload;
        },
        setCryptoFiatMemo: (state, { payload }) => {
            state.recipient.memo = payload;
        },

        patchCryptoFiatTransfer: (state, { payload }) => Object.assign(state, payload || {}),
        resetCryptoFiatTransfer: (state) => ({
            ...initialState,
            currency: state.currency,
        }),
    },
});

export const {
    setCryptoFiatAmount,
    setCryptoFiatCurrency,
    setCryptoFiatNetwork,
    setCryptoFiatPin,
    setCryptoFiatRecipient,
    setCryptoFiatBankName,
    setCryptoFiatRecipientToCurrency,
    setCryptoFiatInstitution,
    setCryptoFiatAccountIdentifier,
    setCryptoFiatAccountName,
    setCryptoFiatMemo,
    patchCryptoFiatTransfer,
    resetCryptoFiatTransfer,
} = cryptoFiatTransferSlice.actions;

export default cryptoFiatTransferSlice.reducer;

// Selectors
export const selectCryptoFiatTransfer = (state) => state.cryptoFiatTransfer;

export const selectCryptoFiatPayload = (state) => {
    const s = state.cryptoFiatTransfer || initialState;
    return {
        amount: String(s.amount ?? ""),
        pin: s.pin || "",
        currency: s.currency,
        network: s.network || "",
        recipient: {
            institution: s.recipient.institution,
            accountIdentifier: s.recipient.accountIdentifier,
            accountName: s.recipient.accountName,
            bankName: s.recipient.bankName,
            memo: s.recipient.memo,
            currency: s.recipient.toCurrency,
        },
    };
};
